module.exports = __webpack_public_path__ + "img/reset_appliance_step_2.c468b78b.png";